import api from '@/services/api'

export default {
	fetchAll() {
		return api.get(`projects/`)
			.then(response => response.data)
	},
	fetch(id) {
		return api.get(`projects/${id}/with_available_groups/`)
			.then(response => response.data)
	},
	create(payload) {
		return api.post(`projects/`, payload)
			.then(response => response.data)
	},
	delete(id) {
		return api.delete(`projects/${id}/`)
			.then(response => response.data)
	},
	fetchSelectedGroup(id) {
		return api.get(`projects/${id}/selected_aggroup/`)
			.then(response => response.data)
	},
	submitWishes(id, priorities) {
		return api.post(`projects/${id}/wishes/`, priorities)
			.then(response => response.data)
	}
}